angular.module('rjmNg.directives').directive 'ceSelect', [
  () ->
    restrict:"E"
    templateUrl: "directive.ceSelect.html"
    priority: 200
    replace: true
    scope:
      items: '='
      active: '='
      extraClass: '@'
      placeholder: '@'
      disabled: '='
    controller: [
      "$scope"
      ($scope) ->

        $scope.setActiveItem = (item) ->
          $scope.active = item

    ]

]
